"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeObjects = mergeObjects;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function convertToReactElement(value) {
  deserializeValue(value, 'props'); // How createElement works for 'key' is inconsistent--you have to pass key as
  // a prop but then it doesn't actually get stored as a prop on the element.
  // It seems to always be 'null' but let's be safe!

  if (value.key !== null && value.key !== undefined) {
    value.props.key = value.key;
  }

  return _react.default.createElement(value.type, value.props);
}

function deserializeValue(obj, key) {
  if (!obj || typeof obj !== 'object') {
    return;
  }

  var value = obj[key];

  if (!value || typeof value !== 'object') {
    return;
  }

  if (Array.isArray(value)) {
    for (var i = 0, l = value.length; i < l; i++) {
      deserializeValue(value, i);
    }

    return;
  }

  if (isProbablySerializedReactElement(value)) {
    obj[key] = convertToReactElement(value);
    return;
  }

  for (var _i = 0, _Object$keys = Object.keys(value); _i < _Object$keys.length; _i++) {
    var _key = _Object$keys[_i];
    deserializeValue(value, _key);
  }

  return;
}

function isProbablySerializedReactElement(value) {
  return value.hasOwnProperty('ref') && value.hasOwnProperty('key') && value.hasOwnProperty('props');
}

function mergeProperty(override, original, key) {
  var originalValue = original[key]; // If there is no override for this field we can use it as-is
  // and don't need to traverse the value deeper

  if (!override.hasOwnProperty(key)) {
    override[key] = originalValue;
    return;
  }

  var overrideValue = override[key]; // Primitives don't require traversal

  if (!overrideValue || typeof overrideValue !== 'object') {
    return;
  }

  if (isProbablySerializedReactElement(overrideValue)) {
    override[key] = convertToReactElement(overrideValue);
    return;
  } // Arrays are opaquely overridden


  if (Array.isArray(overrideValue)) {
    for (var i = 0, l = overrideValue.length; i < l; i++) {
      deserializeValue(overrideValue, i);
    }

    return;
  }

  mergeObjects(overrideValue, originalValue);
}

function mergeObjects(override, original) {
  for (var _i2 = 0, _Object$keys2 = Object.keys(original); _i2 < _Object$keys2.length; _i2++) {
    var key = _Object$keys2[_i2];
    mergeProperty(override, original, key);
  }
}